import LaborDetailsComponent from './LaborDetails';

const LaborDetails = LaborDetailsComponent;

export default LaborDetails;
